import { useState } from 'react';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Stack, Container, Typography, Paper, Chip } from '@material-ui/core';
// components
import Page from '../../components/Page';
import { LoginForm } from '../../components/authentication/login';
import { UpdatePasswordForm } from '../../components/authentication/update-password';
import { VerifyMfaCodeForm } from '../mfa/components/form';
import Logo from 'src/components/authentication/login/TopLogo';
// hooks
import { useTranslation } from 'react-i18next';
// misc
import { currentEnv } from 'src/config';
import { AVAILABLE_MFA_METHODS } from 'src/@types/authentication';
import { SelectMfaMethod } from '../mfa/SelectMfaMethod';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {

  // MFA対応 start --------------
  const [isVerifyMfaCode, setIsVerifyMfaCode] = useState(false); // MFA認証コード入力要否
  const [isNeedNewPassword, setIsNeedNewPassword] = useState(false); // パスワード変更要否
  const [activeMfaMethod, setActiveMfaMethod] = useState<AVAILABLE_MFA_METHODS | null>(null); // 選択済みのMFA方式
  const [isRequiredMfa, setIsRequiredMfa] = useState(false); // MFA認証要否
  const { t } = useTranslation();
  // MFA対応 end ----------------

  return (
    <RootStyle title="Login | Flour">
      <Container maxWidth="sm">
        <ContentStyle>

          {/* 稼働環境表示 */}
          {currentEnv !== 'production' && (
            <>
              <Stack direction="row" alignItems="center" sx={{ mb: 12 }}>
                <Chip
                  style={{
                    flexGrow: 1,
                    width: '50%',
                    fontWeight: 'bold',
                  }}
                  label={'この環境は ' + currentEnv + ' です。'}
                  color="primary"
                  variant="outlined"
                />
              </Stack>
            </>
          )}

          {/* Identity表示 */}
          <Stack direction="row" alignItems="center" sx={{ mb: 3 }}>
            <Box sx={{ flexGrow: 1 }} alignItems="center">
              <Stack sx={{ alignItems: 'center' }}>
                <Logo sx={{ width: '100px', height: '100px' }} />
                <Typography
                  style={{
                    paddingBottom: '0px',
                    fontSize: '40px',
                    fontWeight: '900',
                    fontStyle: 'normal',
                    fontFamily: 'Nunito',
                  }}>
                  Flour
                </Typography>
                <Typography sx={{ color: 'text.secondary' }}>Flour products ordering system</Typography>
              </Stack>
            </Box>
          </Stack>

          {/* 入力フォーム表示 */}
          {isVerifyMfaCode
            ? // MFA認証コード入力フォーム
              <VerifyMfaCodeForm activeMfaMethod={activeMfaMethod} />
            : isNeedNewPassword
              ? // パスワード変更フォーム
                <Box sx={{ mt: 3 }}>
                  <Stack direction="row" alignItems="center" sx={{ mb: 2 }}>
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h4" gutterBottom>
                        {t('updatePassword.title')}
                      </Typography>
                    </Box>
                  </Stack>
                  <UpdatePasswordForm
                    setIsVerifyMfaCode={setIsVerifyMfaCode}
                    setActiveMfaMethod={setActiveMfaMethod}
                    isRequiredMfa={isRequiredMfa}
                  />
                </Box>
              : // ログインフォーム
                <LoginForm
                  setIsVerifyMfaCode={setIsVerifyMfaCode}
                  setIsNeedNewPassword={setIsNeedNewPassword}
                  setActiveMfaMethod={setActiveMfaMethod}
                  setIsRequiredMfa={setIsRequiredMfa}
                />
          }

          <Box style={{ height: '200px' }}></Box>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
